import SwaggerUI from 'swagger-ui-react'
import 'swagger-ui-react/swagger-ui.css'

import React from 'react'

const def = {
  openapi: '3.0.1',
  info: {
    title: 'beta-mav-outlook-api',
    version: '2021-04-12T21:22:30Z',
  },
  servers: [
    {
      url: 'https://api.maverickapp.io',
    },
  ],
  paths: {
    '/partners/leads/{email}': {
      get: {
        parameters: [
          {
            name: 'email',
            in: 'path',
            required: true,
            schema: {
              type: 'string',
            },
          },
        ],
        responses: {
          '200': {
            description: '200 response',
            content: {
              'application/json': {
                schema: {
                  type: 'object',
                  properties: {
                    addedBy: {
                      type: 'string',
                      description:
                        'Indicates if the lead was added by the user or by Maverick Recon.',
                    },
                    company: {
                      type: 'string',
                      description: 'The company the lead is associated with.',
                    },
                    dateAdded: {
                      type: 'string',
                      description: 'The date the lead was added to Maverick.',
                      format: 'date-time',
                    },
                    dateModified: {
                      type: 'integer',
                      description:
                        'Milliseconds elapsed since the UNIX epoch and the last update on the lead.',
                    },
                    doNotEngage: {
                      type: 'boolean',
                      description: 'Do not engage this lead.',
                    },
                    domain: {
                      type: 'string',
                      description: 'The domain associated with the leads email address.',
                    },
                    email: {
                      type: 'string',
                      description: 'The email address of the lead.',
                    },
                    firstName: {
                      type: 'string',
                      description: 'The first name of the lead.',
                    },
                    industry: {
                      type: 'string',
                      description: 'The industry the lead is associated with.',
                    },
                    lastName: {
                      type: 'string',
                      description: 'The last name name of the lead.',
                    },
                    linkedIn: {
                      type: 'string',
                      description: 'The LinkedIn URL of the lead if present.',
                    },
                    maneuver: {
                      type: 'string',
                      description: 'The current Maneuver the lead is set to.',
                    },
                    missionStartDate: {
                      type: 'string',
                      description: 'The date the current Mission started or will be starting.',
                    },
                    name: {
                      type: 'string',
                      description: 'The full name of the lead.',
                    },
                    notes: {
                      type: 'string',
                      description: 'Notes added by the Maverick user for the lead.',
                    },
                    notifyOnComplete: {
                      type: 'boolean',
                      description:
                        'Receive an email from Maverick if this lead completes a maneuver without responding.',
                    },
                    phoneNumber: {
                      type: 'string',
                      description: 'Notes added by the Maverick user for the lead',
                    },
                    sendDates: {
                      type: 'array',
                      maxItems: 5,
                      items: {
                        type: 'object',
                        properties: {
                          name: {
                            type: 'string',
                          },
                          date: {
                            type: 'string',
                          },
                        },
                      },
                      description: 'Maneuver name and send date for current mission.',
                    },
                    sendToMarketing: {
                      type: 'boolean',
                      description: 'Indicates lead should be sent to Marketing.',
                    },
                    title: {
                      type: 'string',
                      description: 'The title of the lead.',
                    },
                    twitter: {
                      type: 'string',
                      description: 'The Twitter URl of the lead if present.',
                    },
                  },
                },
              },
            },
          },
        },
        security: [
          {
            api_key: [],
          },
        ],
      },
      delete: {
        parameters: [
          {
            name: 'email',
            in: 'path',
            required: true,
            schema: {
              type: 'string',
            },
          },
        ],
        responses: {
          '200': {
            description: '200 response',
            content: {
              'application/json': {
                schema: {
                  type: 'object',
                  properties: {
                    deleted: {
                      type: 'boolean',
                      description: 'Indicates the lead was deleted.',
                    },
                  },
                },
              },
            },
          },
        },
        security: [
          {
            api_key: [],
          },
        ],
      },
    },
    '/partners/leads/search': {
      get: {
        parameters: [
          {
            name: 'company',
            in: 'query',
            schema: {
              type: 'string',
            },
          },
        ],
        responses: {
          '200': {
            description: '200 response',
            content: {
              'application/json': {
                schema: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      addedBy: {
                        type: 'string',
                        description:
                          'Indicates if lead was added by Maverick Recon or by Maverick User',
                      },
                      company: {
                        type: 'string',
                        description: 'The company the lead is associated with.',
                      },
                      dateAdded: {
                        type: 'string',
                        description: 'The date the lead was added to Maverick.',
                        format: 'date-time',
                      },
                      dateModified: {
                        type: 'integer',
                        description:
                          'Milliseconds elapsed since the UNIX epoch and the last update on the lead.',
                      },
                      doNotEngage: {
                        type: 'boolean',
                        description: 'Do not engage this lead.',
                      },
                      domain: {
                        type: 'string',
                        description: 'The domain associated with the leads email address.',
                      },
                      email: {
                        type: 'string',
                        description: 'The email address of the lead.',
                      },
                      firstName: {
                        type: 'string',
                        description: 'The first name of the lead.',
                      },
                      industry: {
                        type: 'string',
                        description: 'The industry the lead is associated with.',
                      },
                      lastName: {
                        type: 'string',
                        description: 'The last name name of the lead.',
                      },
                      maneuver: {
                        type: 'string',
                        description: 'The current Maneuver the lead is set to.',
                      },
                      missionStartDate: {
                        type: 'string',
                        description: 'The date the current Mission started or will be starting.',
                      },
                      name: {
                        type: 'string',
                        description: 'The full name of the lead.',
                      },
                      notes: {
                        type: 'string',
                        description: 'Notes added by the Maverick user for the lead.',
                      },
                      notifyOnComplete: {
                        type: 'boolean',
                        description:
                          'Receive an email from Maverick if this lead completes a maneuver without responding.',
                      },
                      phoneNumber: {
                        type: 'string',
                        description: 'Notes added by the Maverick user for the lead',
                      },
                      sendDates: {
                        type: 'array',
                        maxItems: 5,
                        items: {
                          type: 'object',
                          properties: {
                            name: {
                              type: 'string',
                            },
                            date: {
                              type: 'string',
                            },
                          },
                        },
                        description: 'Maneuver name and send date for current mission.',
                      },
                      sendToMarketing: {
                        type: 'boolean',
                        description: 'Indicates lead should be sent to Marketing.',
                      },
                      socials: {
                        type: 'array',
                        description: 'All socials tied to the lead',
                        items: {
                          type: 'string',
                        },
                      },
                      title: {
                        type: 'string',
                        description: 'The title of the lead.',
                      },
                      websites: {
                        type: 'array',
                        description: 'All websites tied to the lead',
                        items: {
                          type: 'string',
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
        security: [
          {
            api_key: [],
          },
        ],
      },
    },
    '/partners/users/reports': {
      get: {
        parameters: [
          {
            name: 'timeRange',
            in: 'query',
            required: true,
            schema: {
              type: 'string',
              description: 'Days of data to fetch, format 1D, 30D, etc.',
              example: '1D',
            },
          },
        ],
        security: [
          {
            api_key: [],
          },
        ],
        responses: {
          '200': {
            description: '200 response',
            content: {
              'application/json': {
                schema: {
                  type: 'object',
                  properties: {
                    sentEmails: {
                      type: 'object',
                      properties: {
                        combined: {
                          type: 'integer',
                          description: 'Sum of all sent emails over time range',
                        },
                        firstTouch: {
                          type: 'integer',
                          description: 'Sum of First Touch emails over time range',
                        },
                        nurture: {
                          type: 'integer',
                          description: 'Sum of Nurture emails over time range',
                        },
                        followUp: {
                          type: 'integer',
                          description: 'Sum of Follow Up emails over time range',
                        },
                      },
                    },
                    prospectsAdded: {
                      type: 'object',
                      properties: {
                        combined: {
                          type: 'integer',
                          description: 'Sum of all prospects added over time range',
                        },
                        firstTouch: {
                          type: 'integer',
                          description: 'Sum of prospects added to First Touch over time range',
                        },
                        nurture: {
                          type: 'integer',
                          description: 'Sum of prospects added to Nurture over time range',
                        },
                        followUp: {
                          type: 'integer',
                          description: 'Sum of prospects added to Follow Up emails over time range',
                        },
                      },
                    },
                    replyData: {
                      type: 'object',
                      properties: {
                        combined: {
                          type: 'array',
                          description: 'Reply stats for all emails',
                          items: {
                            type: 'object',
                            properties: {
                              name: {
                                type: 'string',
                                enum: ['Replied', 'Not Replied'],
                                maxItems: 2,
                              },
                              value: {
                                type: 'integer',
                              },
                            },
                          },
                        },
                        firstTouch: {
                          type: 'array',
                          description: 'Reply stats for First Touch emails',
                          items: {
                            type: 'object',
                            properties: {
                              name: {
                                type: 'string',
                                enum: ['Replied', 'Not Replied'],
                                maxItems: 2,
                              },
                              value: {
                                type: 'integer',
                              },
                            },
                          },
                        },
                        nurture: {
                          type: 'array',
                          description: 'Reply stats for Nurture emails',
                          items: {
                            type: 'object',
                            properties: {
                              name: {
                                type: 'string',
                                enum: ['Replied', 'Not Replied'],
                                maxItems: 2,
                              },
                              value: {
                                type: 'integer',
                              },
                            },
                          },
                        },
                        followUp: {
                          type: 'array',
                          description: 'Reply stats for Follow Up emails',
                          items: {
                            type: 'object',
                            properties: {
                              name: {
                                type: 'string',
                                enum: ['Replied', 'Not Replied'],
                                maxItems: 2,
                              },
                              value: {
                                type: 'integer',
                              },
                            },
                          },
                        },
                      },
                    },
                    openData: {
                      type: 'object',
                      properties: {
                        combined: {
                          type: 'array',
                          description: 'Open stats for all emails',
                          items: {
                            type: 'object',
                            properties: {
                              name: {
                                type: 'string',
                                format: 'date',
                              },
                              opened: {
                                type: 'integer',
                              },
                              sent: {
                                type: 'integer',
                              },
                            },
                          },
                        },
                        firstTouch: {
                          type: 'array',
                          description: 'Open stats for First Touch emails',
                          items: {
                            type: 'object',
                            properties: {
                              name: {
                                type: 'string',
                                format: 'date',
                              },
                              opened: {
                                type: 'integer',
                              },
                              sent: {
                                type: 'integer',
                              },
                            },
                          },
                        },
                        nurture: {
                          type: 'array',
                          description: 'Open stats for Nurture emails',
                          items: {
                            type: 'object',
                            properties: {
                              name: {
                                format: 'date',
                                type: 'string',
                              },
                              opened: {
                                type: 'integer',
                              },
                              sent: {
                                type: 'integer',
                              },
                            },
                          },
                        },
                        followUp: {
                          type: 'array',
                          description: 'Open stats for Follow Up emails',
                          items: {
                            type: 'object',
                            properties: {
                              name: {
                                type: 'string',
                                format: 'date',
                              },
                              opened: {
                                type: 'integer',
                              },
                              sent: {
                                type: 'integer',
                              },
                            },
                          },
                        },
                      },
                    },
                    recentData: {
                      type: 'object',
                      properties: {
                        combined: {
                          type: 'array',
                          description: 'Open stats for all emails',
                          items: {
                            type: 'object',
                            properties: {
                              Recipient: {
                                type: 'string',
                                format: 'email',
                              },
                              'Send Date': {
                                type: 'string',
                                format: 'date',
                              },
                              Replied: {
                                type: 'boolean',
                              },
                              Maneuver: {
                                type: 'string',
                                enum: ['First Touch', 'Follow Up', 'Nurture'],
                              },
                              Touch: {
                                type: 'integer',
                                minimum: 1,
                                maximum: 5,
                              },
                              Subject: {
                                type: 'string',
                              },
                              'Added By': {
                                type: 'string',
                                enum: ['Maverick', 'User'],
                              },
                              'Last Name': {
                                type: 'string',
                              },
                              Industry: {
                                type: 'string',
                              },
                              'First Name': {
                                type: 'string',
                              },
                              'Date Added': {
                                type: 'string',
                                format: 'date-time',
                              },
                              'Opened Count': {
                                type: 'integer',
                              },
                              Opened: {
                                type: 'boolean',
                              },
                              Name: {
                                type: 'string',
                              },
                              Title: {
                                type: 'string',
                              },
                              Company: {
                                type: 'string',
                              },
                            },
                          },
                        },
                        firstTouch: {
                          type: 'array',
                          description: 'Open stats for First Touch emails',
                          items: {
                            type: 'object',
                            properties: {
                              Recipient: {
                                type: 'string',
                                format: 'email',
                              },
                              'Send Date': {
                                type: 'string',
                                format: 'date',
                              },
                              Replied: {
                                type: 'boolean',
                              },
                              Maneuver: {
                                type: 'string',
                                enum: ['First Touch', 'Follow Up', 'Nurture'],
                              },
                              Touch: {
                                type: 'integer',
                                minimum: 1,
                                maximum: 5,
                              },
                              Subject: {
                                type: 'string',
                              },
                              'Added By': {
                                type: 'string',
                                enum: ['Maverick', 'User'],
                              },
                              'Last Name': {
                                type: 'string',
                              },
                              Industry: {
                                type: 'string',
                              },
                              'First Name': {
                                type: 'string',
                              },
                              'Date Added': {
                                type: 'string',
                                format: 'date-time',
                              },
                              'Opened Count': {
                                type: 'integer',
                              },
                              Opened: {
                                type: 'boolean',
                              },
                              Name: {
                                type: 'string',
                              },
                              Title: {
                                type: 'string',
                              },
                              Company: {
                                type: 'string',
                              },
                            },
                          },
                        },
                        nurture: {
                          type: 'array',
                          description: 'Open stats for Nurture emails',
                          items: {
                            type: 'object',
                            properties: {
                              Recipient: {
                                type: 'string',
                                format: 'email',
                              },
                              'Send Date': {
                                type: 'string',
                                format: 'date',
                              },
                              Replied: {
                                type: 'boolean',
                              },
                              Maneuver: {
                                type: 'string',
                                enum: ['First Touch', 'Follow Up', 'Nurture'],
                              },
                              Touch: {
                                type: 'integer',
                                minimum: 1,
                                maximum: 5,
                              },
                              Subject: {
                                type: 'string',
                              },
                              'Added By': {
                                type: 'string',
                                enum: ['Maverick', 'User'],
                              },
                              'Last Name': {
                                type: 'string',
                              },
                              Industry: {
                                type: 'string',
                              },
                              'First Name': {
                                type: 'string',
                              },
                              'Date Added': {
                                type: 'string',
                                format: 'date-time',
                              },
                              'Opened Count': {
                                type: 'integer',
                              },
                              Opened: {
                                type: 'boolean',
                              },
                              Name: {
                                type: 'string',
                              },
                              Title: {
                                type: 'string',
                              },
                              Company: {
                                type: 'string',
                              },
                            },
                          },
                        },
                        followUp: {
                          type: 'array',
                          description: 'Open stats for Follow Up emails',
                          items: {
                            type: 'object',
                            properties: {
                              Recipient: {
                                type: 'string',
                                format: 'email',
                              },
                              'Send Date': {
                                type: 'string',
                                format: 'date',
                              },
                              Replied: {
                                type: 'boolean',
                              },
                              Maneuver: {
                                type: 'string',
                                enum: ['First Touch', 'Follow Up', 'Nurture'],
                              },
                              Touch: {
                                type: 'integer',
                                minimum: 1,
                                maximum: 5,
                              },
                              Subject: {
                                type: 'string',
                              },
                              'Added By': {
                                type: 'string',
                                enum: ['Maverick', 'User'],
                              },
                              'Last Name': {
                                type: 'string',
                              },
                              Industry: {
                                type: 'string',
                              },
                              'First Name': {
                                type: 'string',
                              },
                              'Date Added': {
                                type: 'string',
                                format: 'date-time',
                              },
                              'Opened Count': {
                                type: 'integer',
                              },
                              Opened: {
                                type: 'boolean',
                              },
                              Name: {
                                type: 'string',
                              },
                              Title: {
                                type: 'string',
                              },
                              Company: {
                                type: 'string',
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    '/partners/users/dnc': {
      get: {
        security: [
          {
            api_key: [],
          },
        ],
        responses: {
          '200': {
            description: '200 response',
            content: {
              'application/json': {
                schema: {
                  type: 'object',
                  properties: {
                    leads: {
                      type: 'array',
                      description: 'All leads set to do not engage',
                      items: {
                        type: 'string',
                        format: 'email',
                      },
                    },
                    domains: {
                      type: 'array',
                      description: 'All companies set to do not engage',
                      items: {
                        type: 'string',
                        format: 'hostname',
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
      put: {
        security: [
          {
            api_key: [],
          },
        ],
        requestBody: {
          description:
            'All companies set to do not engage, this should include all companies, not just new companies to add',
          required: true,
          content: {
            'application/json': {
              schema: {
                type: 'object',
                properties: {
                  domains: {
                    type: 'array',
                    description:
                      'All companies set to do not engage, this should include all companies, not just new companies to add',
                    items: {
                      type: 'string',
                      format: 'hostname',
                    },
                  },
                },
              },
            },
          },
        },
        responses: {
          '200': {
            description: '200 response',
            content: {
              'application/json': {
                schema: {
                  type: 'object',
                  properties: {
                    leads: {
                      type: 'array',
                      description: 'All leads set to do not engage',
                      items: {
                        type: 'string',
                        format: 'email',
                      },
                    },
                    domains: {
                      type: 'array',
                      description: 'All companies set to do not engage',
                      items: {
                        type: 'string',
                        format: 'hostname',
                      },
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
    '/partners/company/{domain}': {
      get: {
        parameters: [
          {
            name: 'domain',
            in: 'path',
            required: true,
            schema: {
              type: 'string',
              format: 'hostname',
            },
          },
        ],
        security: [
          {
            api_key: [],
          },
        ],
        responses: {
          '200': {
            description: '200 response',
            content: {
              'application/json': {
                schema: {
                  type: 'object',
                  properties: {
                    id: {
                      type: 'integer',
                    },
                    name: {
                      type: 'string',
                    },
                    address: {
                      type: 'object',
                      properties: {
                        street: {
                          type: 'string',
                        },
                        city: {
                          type: 'string',
                        },
                        state: {
                          type: 'string',
                        },
                      },
                    },
                    details: {
                      type: 'string',
                    },
                    linkedin: {
                      type: 'string',
                    },
                    headCount: {
                      type: 'string',
                    },
                    revenueBucket: {
                      type: 'string',
                    },
                    industry: {
                      type: 'string',
                    },
                    website: {
                      type: 'string',
                    },
                    dncCompany: {
                      type: 'boolean',
                    },
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  components: {
    securitySchemes: {
      api_key: {
        type: 'apiKey',
        name: 'x-api-key',
        in: 'header',
      },
    },
  },
}

const Swagger = (): JSX.Element => {
  return (
    <div className="dashboard" style={{ overflow: 'auto' }}>
      <SwaggerUI spec={def} />
    </div>
  )
}

export default Swagger
